import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { AlertService } from 'src/app/services/alert.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { PasswordService } from '../../../microempresario/services/password.service';
import { UserService } from '../../../services/user.service';
import { CambiarContrasenaService } from '../../Service/cambiar-Contrasena.service';
import { Router } from '@angular/router';
import { PASSWORD_COMPLEXITY_PATTERN } from 'src/app/shared/utils/validation.constants';
import { AnalyticsTagService } from 'src/app/services/analytics-tag.service';

declare var $:any;

@Component({
    selector: 'app-cambiar-contrasena',
    templateUrl: './cambiar-contrasena.component.html',
    styleUrls: ['./cambiar-contrasena.component.scss'],
    standalone: false
})
export class CambiarContrasenaComponent implements OnInit {
  idCliente: number;
  isVisible: boolean = false;
  isVisibleNueva: boolean = false;
  isConfirm: boolean = false;
  isLoading: boolean = false;
  validarContrasena = PASSWORD_COMPLEXITY_PATTERN;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private password: PasswordService,
    private user: UserService,
    private CambiarContrasenaService: CambiarContrasenaService,
    private alertaService: AlertService,
    private router: Router,
    private _sweetAlert:SweetAlertService,
    private _analyticsTag: AnalyticsTagService) { }

     public cambioContraForm = this.formBuilder.group({
      contraActual: ['', [Validators.required, Validators.minLength(8), Validators.pattern(this.validarContrasena)]],
      contraNueva: ['', [Validators.required, Validators.minLength(8), Validators.pattern(this.validarContrasena)]],
      confirContraNueva: ['', Validators.required]
    },{
      validator: [this.password.matchPassword('contraNueva', 'confirContraNueva'), this.password.noRepeatPassword('contraActual','contraNueva')]
    });

  ngOnInit(){
    this.idCliente = this.user.getUser().idUsuario;
  }

  showPassword() {
    this.isVisible = !this.isVisible;
  }
  showPasswordNueva() {
    this.isVisibleNueva = !this.isVisibleNueva;
  }

  showConfirmPassword() {
    this.isConfirm = !this.isConfirm;
  }
  trackVolver(){
    this._analyticsTag.trackCtaClick({
      ctaLabel: 'Volver',
      ctaSection: 'cambiar-contrasena-if',
      ctaComponent: 'cambiar-contrasena-if',
      ctaElementId: 'btn-cambiar-contrasena-if-volver',
      hu: '8337',
    });
  }

  guardarContraNueva(){
    this._analyticsTag.trackCtaClick({
      ctaLabel: 'Guardar',
      ctaSection: 'cambiar-contrasena-if',
      ctaComponent: 'cambiar-contrasena-if',
      ctaElementId: 'btn-cambiar-contrasena-if-guardar',
      hu: '8337',
    });
    const body:any = {
      idUsuario: Number(this.idCliente),
      contraseniaAnterior: this.cambioContraForm.get('contraActual').value,
      contraseniaNueva: this.cambioContraForm.get('contraNueva').value
    }
    this.isLoading = true;
    this.CambiarContrasenaService.getCambioContrasena(body).subscribe((data:any)=>{
      if(data.exitoso == 'true'){
        this._sweetAlert.successModal('Cambios Guardados').then((result)=>{
          if(result.isConfirmed){
            this.router.navigate(['/intermediario/home']);
          }
        });
        // $('#mensajeModal').modal('show');
      }else{
        this._sweetAlert.errorModal("Error!",true,data.error);
        this.isLoading = false;
      }
    })
  }

  validateField(key: string) {
    return (
        (this.cambioContraForm.get(key).dirty ||
            this.cambioContraForm.get(key)?.touched) &&
        this.cambioContraForm.get(key)?.invalid
    );
  }

}
